import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useCollection(path) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/${path}`);
      setItems(data);
    } catch {
      /* silent */
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => { load(); }, [load]);

  const create = async (body) => {
    const { data } = await api.post(`/${path}`, body);
    setItems((p) => [...p, data]);
    return data;
  };

  const update = async (id, body) => {
    const { data } = await api.put(`/${path}/${id}`, body);
    setItems((p) => p.map((i) => (i.id === id ? data : i)));
    return data;
  };

  const remove = async (id) => {
    await api.delete(`/${path}/${id}`);
    setItems((p) => p.filter((i) => i.id !== id));
    toast.success("Deleted");
  };

  return { items, loading, load, create, update, remove, setItems };
}
